import User from '@/services/api/User';
import axios from 'axios';

export default class ApiFunctions {
  static async getByUser(entity, urlParams) {
    const user = User.get();
    let parsedParams = urlParams;

    if (urlParams) parsedParams['user._id'] = user._id;
    else parsedParams = { 'user._id': user._id };

    const query = ApiFunctions.toParams(parsedParams);

    return ApiFunctions.simpleRequest(axios.get(`/${entity}${query}`));
  }

  static async getAll(entity, urlParams) {
    const query = ApiFunctions.toParams(urlParams);

    return ApiFunctions.simpleRequest(axios.get(`/${entity}${query}`));
  }

  static async getPaged(entity, limit, page, urlParams) {
    const query = (!urlParams) ? '?' : ApiFunctions.toParams(urlParams);

    return ApiFunctions.pagedRequest(axios.get(`/${entity}${query}&_limit=${limit}&_page=${page}`));
  }

  static async getPagedByUser(entity, limit, page, urlParams) {
    let parsedParams = urlParams;
    const user = User.get();

    if (urlParams) parsedParams.user = user;
    else parsedParams = { user };

    const query = ApiFunctions.toParams(parsedParams);

    return ApiFunctions.pagedRequest(axios.get(`/${entity}${query}&_limit=${limit}&_page=${page}`));
  }

  static async getOne(entity, id, urlParams) {
    const query = ApiFunctions.toParams(urlParams);

    return ApiFunctions.simpleRequest(axios.get(`/${entity}/${id}${query}`));
  }

  static async create(entity, object) {
    return ApiFunctions.simpleRequest(axios({
      url: `/${entity}`,
      method: 'post',
      data: object,
    }),
    );
  }

  static async login(entity, object) {
    return ApiFunctions.simpleRequest(axios({
        url: `/${entity}`,
        method: 'get',
        data: object,
      }),
    );
  }

  static async simpleRequest(request) {
    try {
      const tasks = await request;

      return tasks.data;
    } catch (apiErrors) {
      // TODO error handling

      throw new Error(apiErrors);
    }
  }

  static async pagedRequest(request) {
    try {
      const response = await request;

      return {
        total_count: response.headers['x-total-count'],
        items: response.data,
      };
    } catch (apiErrors) {
      // TODO error handling

      throw new Error(apiErrors);
    }
  }

  static toParams(params) {
    if (!params) return '';
    return `?${Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`;
  }
}



// WEBPACK FOOTER //
// ./src/services/api/ApiFunctions.js